import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  MenuItem,
  Grid,
  TableCell,
  Collapse,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import moment from "moment";
import Loading from "../loading";
import { styles } from "./styles";
import Snackbar from "../snackbar";
import { _parsePhoneNumber } from "../../partials/validateNumber";
import EditForm from "./edit";
import TableFormat from "../../partials/TableFormat";
import Header from "../../partials/header";
import FilterList from "../../partials/filterList";
import InputFormat from "../../partials/inputForm";
import { formatDatetime } from "../../utils/setting";
const headCells = [
  {
    key: "isUser",
    numeric: false,
    width: "5%",
    disablePadding: false,
    label: "user_voucher_is_user",
  },
  {
    key: "title",
    numeric: false,
    width: "5%",
    disablePadding: false,
    label: "voucher_listvoucher_tablehead_voucher_title",
  },
  {
    key: "mobile",
    numeric: false,
    disablePadding: false,
    label: "user_voucher_mobile",
  },
  {
    key: "voucherCode",
    numeric: false,
    disablePadding: false,
    label: "user_voucher_voucherCode",
  },
  {
    key: "imageVoucher",
    numeric: false,
    disablePadding: false,
    label: "user_voucher_imageVoucher",
  },
  {
    key: "isUsed",
    numeric: false,
    disablePadding: false,
    label: "user_voucher_isUsed",
  },
  {
    key: "endDate",
    numeric: false,
    disablePadding: false,
    label: "user_voucher_endDate",
  },
  {
    key: "createdAt",
    styleComlumn: true,
    numeric: false,
    disablePadding: false,
    label: "user_voucher_sent_at",
  },
];
const listIsUsed = [
  {
    value: 0,
    label: "user_voucher_isUsed"
  },
  {
    value: 1,
    label: "user_voucher_unUsed"
  },
]
const listExpiredVoucher = [
  {
    value: "valid",
    label: "user_voucher_valid"
  },
  {
    value: "expired_after_one_day",
    label: "user_voucher_expired_after_one_day"
  },
  {
    value: "expired",
    label: "user_voucher_expired"
  },
]
class UserVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "",
      orderBy: "",
      selected: [],
      collapse: [],
      isUsed: -1,
      expiredVoucher: "",
      from: moment().subtract(3, "months").startOf("month").valueOf(),
      to: moment().endOf("month").valueOf(),
      openDrawer: false,
      listFilter: {
        isUsed: "",
        expiredVoucher: ""
      },
    };
  }
  checkListFilter = () => {
    let { isUsed = -1, expiredVoucher, listFilter } = this.state;
    listFilter["isUsed"] = listIsUsed.find(item => item.value === isUsed);
    listFilter["isUsed"] = listFilter["isUsed"] ? listFilter["isUsed"].label : "";
    listFilter["expiredVoucher"] = listExpiredVoucher.find(item => item.value === expiredVoucher);
    listFilter["expiredVoucher"] = listFilter["expiredVoucher"] ? listFilter["expiredVoucher"].label : "";
    this.setState({ listFilter })
  }
  getList = async (data) => {
    let { rowsPerPage } = this.mTable.state;
    let query = {
      ...this.state,
      ...this.mTable.state,
      limit: rowsPerPage,
      ...data,
    };
    if (query.from) {
      query.from = moment(query.from).startOf("day").valueOf();
    }
    if (query.to) {
      query.to = moment(query.to).endOf("day").valueOf();
    }
    delete query.rowsPerPage;
    this.loading.startLoading();
    this.props.getList(query);
    this.loading.stopLoading();
    this.checkListFilter()
  };

  componentDidMount = async () => { };
  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  isSelected = (id) => {
    return this.state.selected.indexOf(id) !== -1;
  };
  handleCheckbox = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };
  afterEdit = (check) => {
    let { t } = this.props;
    this.handleOpenCollapes(-1);
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("user_voucher_updated_successful"));
      this.setState({
        isUsed: -1,
        expiredVoucher: "",
        from: null,
        to: null,
        search: "",
      });
      this.getList();
    } else if (check.error === 1125)
      this.mSnackbar.handleClick("Voucher deleted", "error");
    else this.mSnackbar.handleClick(check.message, "error");
  };
  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };
  handleFilter = (e) => {
    let { isUsed = -1, expiredVoucher } = this.state;
    let query = {};
    if (e.target.name === "expiredVoucher") {
      expiredVoucher = e.target.value;
      query = Object.assign(query, {
        expiredVoucher: expiredVoucher,
        isUsed: isUsed,
      });
    } else {
      isUsed = Number(e.target.value);
      query = Object.assign(query, {
        isUsed: Number(isUsed),
        expiredVoucher: expiredVoucher,
      });
    }
    this.setState({ isUsed, expiredVoucher });
  };
  handleDelete = async (selected) => {
    this.loading.startLoading();
    let check = await this.props.deleteUserVoucher({ _id: selected });
    if (check && check.code === 1) {
      this.snackbar("Delete successful");
      this.loading.stopLoading();
      return true;
    } else {
      this.snackbar(check.message, "error");
      this.loading.stopLoading();
      return false;
    }
  };

  handleOpenCollapes = (id) => {
    let { collapse } = this.state;
    collapse = collapse.map((e, index) => {
      if (index !== id) return false;
      else return e;
    });
    collapse[id] = !collapse[id];
    this.setState({ collapse: collapse });
  };
  handleChangeDate = (start, end) => {
    this.setState({
      from: start,
      to: end,
    });
    this.getList({ from: start, to: end });
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const { listUserVoucher = [], classes } = this.props;

    return (
      <TableRow key={index}>
        <TableCell
          colSpan={10}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditForm
              item={index}
              data={listUserVoucher.find((e) => e._id === row.id)}
              handleClose={() => this.handleOpenCollapes(index)}
              afterEdit={this.afterEdit}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        isUsed: -1,
        expiredVoucher: "",
        from: moment().subtract(3, "months").startOf("month").valueOf(),
        to: moment().endOf("month").valueOf(),
      },
      function () {
        _this.getList();
      }
    );
  };
  handleFilterDate = (from, to) => {
    this.setState({ from: from, to: to }, function () {
      this.getList();
    });
  };
  render() {
    const {
      classes,
      t,
      listUserVoucher = [],
      total,
      count,
      listVoucher = [],
    } = this.props;
    const { isUsed, expiredVoucher, from, to, collapse, listFilter } = this.state;
    return (
      <div>
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getList}
        >
          <Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("user_voucher_usage_status")}
              onChange={this.handleFilter}
              name="isUsed"
              required
              margin="normal"
              value={isUsed}
              fullWidth
              InputLabelProps={{
                className: classes.label,
              }}
            >
              <MenuItem value={-1}>{t("user_voucher_show_all")}</MenuItem>
              {listIsUsed.map((item, index) => {
                return (
                  <MenuItem
                    key={`item-is-use-${index}`}
                    value={item.value}
                  >
                    {t(item.label)}
                  </MenuItem>
                )
              })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("user_voucher_expired_date")}
              onChange={this.handleFilter}
              name="expiredVoucher"
              margin="normal"
              required
              value={expiredVoucher}
              fullWidth
              InputLabelProps={{
                className: classes.label,
              }}
            >
              <MenuItem value={""}>{t("user_voucher_show_all")}</MenuItem>
              {listExpiredVoucher.map((item, index) => {
                return (
                  <MenuItem
                    key={`item-expired-date-${index}`}
                    value={item.value}
                  >
                    {t(item.label)}
                  </MenuItem>
                )
              })}
            </InputFormat>
          </Grid>
        </FilterList>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Header
          session={t("sidebar_promotion")}
          title={t("sidebar_user_voucher")}
          showFilterDate={true}
          handleFilterDate={this.handleFilterDate}
          from={from}
          to={to}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          contentDialog={t(
            "user_voucher_sure_that_you_want_to_delete_this_voucher"
          )}
          onDelete={this.handleDelete}
          title={t("sidebar_user_voucher")}
          showFilter={true}
          openFilter={(e) => this.showFilter(e)}
          listFilter={listFilter}
          placeholder={t("user_voucher_search_by_voucherCode_customerName")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          rows={listUserVoucher.map((row) => {
            let parsePhone = _parsePhoneNumber(row.countryCode, row.mobile);
            let filter = listVoucher.find(
              (ele) => ele.code === row.voucherCode
            );
            let imgVoucher = filter ? filter.imgVoucher : "";
            let expiredDay =
              (row.expired - new Date().getTime()) / 1000 / 60 / 60 / 24;
            let status =
              expiredDay < 0
                ? "expired"
                : 0 < expiredDay && expiredDay <= 1
                  ? "will_expired"
                  : "non_expired";
            let styleComlumn = classes[status + "_border"];
            return {
              id: row._id,
              isUser: row.isUser ? (
                <Tooltip title={t("user_voucher_user_is_registered_account")}>
                  <img
                    style={{ width: "1.5rem" }}
                    alt="logo"
                    src="../../../rectangle-logo.png"
                  />
                </Tooltip>
              ) : (
                ""
              ),
              title: filter ? filter.title : "",
              // customerName: row.customerName,
              mobile: (
                <div className={classes.customColumn}>
                  <div>
                    {parsePhone.isValid
                      ? parsePhone.format_internal
                      : row.countryCode + "" + row.mobile}
                  </div>
                  <div className={classes.customerNameRow}>
                    {row.customerName}
                  </div>
                </div>
              ),
              voucherCode: row.voucherCode,
              imageVoucher: imgVoucher && (
                <div>
                  <img
                    className={classes.imgVoucher}
                    alt="imgVoucher"
                    src={imgVoucher}
                  />
                </div>
              ),
              isUsed: row.times - row.isUsed + "/" + row.times,
              endDate: formatDatetime(row.expired),
              createdAt: formatDatetime(row.createdAt),
              styleComlumn: styleComlumn,
            };
          })}
        />
      </div>
    );
  }
}

UserVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listUserVoucher: state.userVouchers.listUserVoucher,
  listVoucher: state.userVouchers.listVoucher,
  total: state.userVouchers.total,
  count: state.userVouchers.count,
});

const mapDispatch = (dispatch) => ({
  getList: dispatch.userVouchers.getListUserVoucher,
  deleteUserVoucher: dispatch.userVouchers.deleteUserVoucher,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(UserVoucher)
  )
);
